import React, { useCallback, useContext, useEffect } from 'react';
import useDuplicationWarning from '../../MetricPopup/MetricForm/NormalMetricForm/useIsDraftADuplicate';
import MetricListItem from '../../../../../components/Inputs/MetricPicker/MetricPickerPopup/MetricListItem';
import { MergeDuplicateMetricsContext } from './MergeDuplicateMetrics';
import metricTypeCheckers from '../../../../../types/metricTypeCheckers';

const DuplicateMetricSelector = ({
  metric,
}: {
  metric: Metrics.NormalMetric;
}) => {
  const {
    primaryMetric,
    setPrimaryMetric,
    duplicateMetrics,
    setDuplicateMetrics,
  } = useContext(MergeDuplicateMetricsContext);

  const onMetricClicked = useCallback(
    (metric: Metrics.Metric) => {
      if (!metricTypeCheckers.isNormalMetric(metric)) return;

      setPrimaryMetric(metric);
    },
    [setPrimaryMetric],
  );

  useEffect(() => {
    if (!duplicateMetrics.map((m) => m.id).includes(metric.id)) {
      setDuplicateMetrics([...duplicateMetrics, metric]);
    }
  }, [duplicateMetrics, metric, setDuplicateMetrics]);

  return (
    <MetricListItem
      key={metric.id}
      metric={metric}
      selectedMetricId={primaryMetric?.id}
      onMetricClicked={onMetricClicked}
    />
  );
};

const Gate = ({ metric }: { metric: Metrics.NormalMetric }) => {
  const isDuplicate = useDuplicationWarning({ metricDraft: metric });

  const duplicates = isDuplicate.duplicates.filter(
    (metric) => metric.status !== 'archived',
  );

  if (!duplicates.length || metric.status === 'archived') return null;

  return <DuplicateMetricSelector metric={metric} />;
};

export default Gate;
